export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/cartoon-pattern.b13b580.svg";